import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../../baseQuery/basePlatformQuery';
import { Banner } from './types';

const BASE_URL = '/api/v1/platform/notifications'

export const bannerApi = createApi({
    reducerPath: 'bannerApi',
    baseQuery,
    tagTypes: ['banner'],
    endpoints: (builder) => ({
        getCurrentBanner: builder.query<Banner, void>({
            query: () => ({
                url: `${BASE_URL}/current`,
                method: 'GET',
            }),
            providesTags: ['banner'],
        }),
    }),
});

export const { useGetCurrentBannerQuery } = bannerApi;